import axios from "axios";
import { API_URL, getAuthHeader } from ".";

export interface MemberEngagementRow {
  memberId: number;
  name: string | null;
  phone: string | null;
  subscriptionName: string | null;
  lastLoginDate: string | null;
  lastEventName: string | null;
  lastEventDate: string | null;
  lastEventAttended: boolean | null;
  userCount: number;
  status: string;
  latestNoteUtc: string | null;
}

export interface OutreachNote {
  id: number;
  userId: number | null;
  userName: string | null;
  authorUserId: number;
  authorName: string | null;
  noteType: string;
  note: string;
  createdUtc: string;
}

export interface OutreachUserOption {
  id: number;
  name: string;
}

export interface MemberOutreachNotes {
  notes: OutreachNote[];
  users: OutreachUserOption[];
}

class MemberEngagementApi {
  static getList(portalDays: number, eventDays: number, status: string) {
    const params = new URLSearchParams();
    params.set("portalDays", String(portalDays));
    params.set("eventDays", String(eventDays));
    params.set("status", status);
    return axios.get<MemberEngagementRow[]>(
      `${API_URL}/api/member-engagement?${params.toString()}`,
      getAuthHeader()
    );
  }

  static getNotes(memberId: number) {
    return axios.get<MemberOutreachNotes>(
      `${API_URL}/api/member-engagement/${memberId}/notes`,
      getAuthHeader()
    );
  }

  static addNote(
    memberId: number,
    noteType: string,
    note: string,
    userId?: number | null
  ) {
    return axios.post(
      `${API_URL}/api/member-engagement/${memberId}/notes`,
      { noteType, note, userId: userId ?? null },
      getAuthHeader()
    );
  }
}

export default MemberEngagementApi;
